import { render, staticRenderFns } from "./reporteriaAsesor.vue?vue&type=template&id=68aa8a29"
import script from "./reporteriaAsesor.vue?vue&type=script&lang=js"
export * from "./reporteriaAsesor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports